import React from 'react';

import Link from './Link';
import {cx} from '../util';

const defaultClasses = `
  px-2.5
  py-2
  -ml-px
  border
  border-gray-300
  shadow-sm
  text-base
  font-medium
  text-gray-700
  whitespace-nowrap
  hover:bg-gray-100
  focus:outline-none
  focus:z-20
  focus:ring-1
  focus:ring-indigo
  focus:border-indigo
`;

export const ConnectedButton = ({
  selected, className, href, asLink, ...props
}) => {
  const classes = cx(defaultClasses, {'z-10 bg-gray-100': selected}, className);

  if (asLink && href) return <Link className={classes} href={href} {...props} />;

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  if (href) return <a className={classes} href={href} {...props} />;

  return <button type="button" className={classes} {...props} />;
};

export const ConnectedButtonGroup = ({className, ...props}) => (
  <div
    className={cx(
      'flex',
      '[&>:first-child_button]:ml-0 [&>:first-child_button]:rounded-l-lg',
      '[&>:last-child_button]:rounded-r-lg',
      '[&>button:first-child]:ml-0 [&>button:first-child]:rounded-l-lg',
      '[&>button:last-child]:rounded-r-lg',
      className,
    )}
    {...props}
  />
);
